import React from 'react';
import EmailIcon from '@/lib/vendor/@material-ui/icons/src/Email';
import LWTooltip from "../../common/LWTooltip";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('NewUserDMSummary', (theme: ThemeType) => ({
  root: {
    ...theme.typography.body2,
    color: theme.palette.grey[600],
  },
  icon: {
    height: 13,
    width: 13,
    position: "relative",
    top: 1
  },
}));

export const NewUserDMSummary = ({user}: {
  user: SunshineUsersList,
}) => {
  const classes = useStyles(styles);

  if (!user.usersContactedBeforeReview?.length) return null
  
  return <div className={classes.root}>
    <LWTooltip title={'Number of users DMed'}>
      {user.usersContactedBeforeReview.length} <EmailIcon className={classes.icon}/>
    </LWTooltip>
  </div>
}

export default NewUserDMSummary;


